// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const TABLE_ACTIONS = {
    EDIT: 'edit',
    REMOVE: 'remove',
    IPS_REMOVE: 'ips-remove',
    IPS_BATCH_REMOVE: 'ips-batch-remove',
};